import script from "./lista-helpdesk.vue?vue&type=script&setup=true&lang=js"
export * from "./lista-helpdesk.vue?vue&type=script&setup=true&lang=js"

import "./lista-helpdesk.vue?vue&type=style&index=0&id=9cfaecde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cfaecde"]])

export default __exports__